export default __webpack_public_path__ + "static/media/bannerzequinhamobile.1d7f8b31.png";